/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface LinkedInSignatureResponse {
  id: string;
  name: string;
  body_text: string;
  created_at: string;
  updated_at: string;
}
